export const connectorLocalStorageKey = "connectorId";
export const connectorChainLocalStorageKey = "connectorNetwork";

export const appConfig = {
  api: {
    graphQL: process.env.REACT_APP_GRAPHQL_PROVIDER ?? "",
  },
  google: {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID ?? "",
  },
  captcha: {
    key: process.env.REACT_APP_CAPTCHA_SITE_KEY ?? "",
  },
  supportChainIds: {
    default: process.env.REACT_APP_SUPPORTED_CHAIN_IDS ?? "",
    gainsLock: process.env.REACT_APP_SUPPORTED_CHAIN_IDS_GAINS_LOCK ?? "",
  },

  blockpass: {
    id: {
      default: process.env.REACT_APP_BLOCKPASS_CLIENT_ID_DEFAULT ?? '',
      lithuania: process.env.REACT_APP_BLOCKPASS_CLIENT_ID_LITHUANIA ?? '',
      fatf: process.env.REACT_APP_BLOCKPASS_CLIENT_ID_FATF ?? '',
    },
    countries: {
      fatf: process.env.REACT_APP_FATF_COUNTRIES ?? '',
      blocked: process.env.REACT_APP_BLOCKED_COUNTRIES ?? '',
    }
  },

  alchemy: {
    key: process.env.REACT_APP_ALCHEMY_PROVIDER_ID ?? ''
  },

  infura: {
    key: process.env.REACT_APP_INFURA_PROVIDER_ID ?? ''
  },

  walletConnect: {
    projectId: process.env.REACT_APP_WALLET_CONNECT_CLOUD_PROJECT_ID ?? ''
  },
  web3Auth: {
    clientId: process.env.REACT_APP_WEB3AUTH_CLIENT_ID ?? '',
    enabled: process.env.REACT_APP_WEB3AUTH_ENABLED === 'true',
    isMainnet: process.env.REACT_APP_WEB3AUTH_ENABLE_MAINNET === 'true',
  },
  latestLockContractVersion: process.env.REACT_APP_LATEST_LOCK_CONTRACT_VERSION ?? 1,
  lockContractSupportedVersions: process.env.REACT_APP_LOCK_CONTRACT_SUPPORTED_VERSIONS ?? '1',
  giveAwayProjectId: process.env.REACT_APP_GIVEAWAY_PROJECT_IDS?.split(',') ?? [],
  giveAwayUserTiers: process.env.REACT_APP_GIVEAWAY_USER_TIERS?.split(',').map((each: string) => Number(each)) ?? [],
  displayStakingAd: process.env.REACT_APP_DISPLAY_STAKING_AD === 'true',
};
